let _ = require("ES/lib/lodash");
let esUtils = require("ES/utils/esUtils");
let AuthedUserSession = require("./AuthedUserSession");

let optional = function () {
  return true;
};

let buildAddressFields = function (Displaylists, data) {
  return {
    address: {
      label: "Address",
      type: "textarea",
      placeholder: "Street Address",
      validate: optional
    },
    city: {
      label: "City",
      type: "text",
      placeholder: "City",
      validate: optional
    },
    st: {
      label: "State/Prov",
      type: "esState",
      Displaylists: Displaylists,
      country: (data && data.country) || null,
      validate: optional
    },
    zip: {
      label: "Postal code",
      type: "text",
      placeholder: "Zip/Postal code",
      validate: optional
    },
    country: {
      label: "Country",
      type: "esCountry",
      validate: optional,
      Displaylists: Displaylists
    }
  };
};


let extractIdsFromKeys = function (data, regex) {
  return _.uniq(_.map(_.filter(_.keys(data), function (key) {
    return regex.test(key);
  }), function (key) {
    return _.parseInt(regex.exec(key)[1]);
  }));
};

let filterKeysOut = function (data, regex) {
  return _.object(_.reject(_.pairs(data), function (pair) {
    return regex.test(pair[0]);
  }));
};

let floatOr0 = function (num) {
  let n = parseFloat(num);
  if (_.isNaN(n)) {
    return 0;
  }
  return n;
};

/**
 * Used everywhere a dropdown list of speakers is shown
 *
 * @param Displaylists
 * @param include_archived
 * @returns {*}
 */
let getSpeakerNamesBySid = function (Displaylists, include_archived = true) {
  let common_actionlist_sid                    = (Displaylists && Displaylists.universal && Displaylists.universal.USE_COMMON_ACTIONLISTS_SID) || null,
      user_has_access_to_common_actionlist_sid = _.includes(AuthedUserSession.all_sids_i_have_permissions_for, common_actionlist_sid);

  //don't bother sorting these b/c js objects with numeric keys forces its own sorting
  return _.object(_.compact(_.map(Displaylists && Displaylists.perspeaker, function ({sid, name_first, name_last, name_full, companies, archived}) {
    if (!_.contains(companies, _.get(AuthedUserSession, ["activeCompany", "COMPANY_ID"]))) {
      return null;
    }
    if (!include_archived && archived) {
      return null;
    }
    let displayname = _.isString(name_full) ? name_full.trim() : "";
    if (!esUtils.isBlank(name_first) && !esUtils.isBlank(name_last)) {
      displayname = name_last.trim() + ", " + name_first.trim();
    }
    return (esUtils.isBlank(displayname) || (!user_has_access_to_common_actionlist_sid && (sid == common_actionlist_sid))) ? null : [sid, displayname];
  })));
};

/**
 * Used to build the dropdown for empire mode (where superadmin has access to all speakers regardless of active company)
 *
 * @param Displaylists
 * @param include_archived
 * @returns {*}
 */
let getSpeakerNamesBySidForEveryCompany = function (Displaylists, include_archived = true) {
  let r = _.map(Displaylists && Displaylists.perspeaker, function ({sid, name_first, name_last, name_full, archived}) {
    if (archived) {
      return null;
    }
    let displayname = _.isString(name_full) ? name_full.trim() : "";
    if (!esUtils.isBlank(name_first) && !esUtils.isBlank(name_last)) {
      displayname = name_last.trim() + ", " + name_first.trim();
    }
    return [sid, displayname];
  });

  return _.object(_.compact(r));
};

module.exports = {
  optional,
  buildAddressFields,
  extractIdsFromKeys,
  filterKeysOut,
  floatOr0,
  getSpeakerNamesBySid,
  getSpeakerNamesBySidForEveryCompany,
  v: {
    optional,
    required(value, field) {
      let valid = false;
      if (_.isBoolean(value)) {
        valid = value === true;
      } else if (_.isNumber(value)) {
        valid = value !== 0;
      } else if (_.isDate(value)) {
        valid = true;
      } else {
        valid = !_.isEmpty(value);
      }
      return valid || ((field.label || field.name) + " is required");
    },
    blankOr(otherValidator) {
      return function (value) {
        return esUtils.isBlank(value) || otherValidator(value);
      };
    },
    integer(value) {
      return /^\s*[-+]?[0-9]+\s*$/.test(value) || "Enter a number";
    },
    positive_integer(value) {
      return /^\s*[0-9]+\s*$/.test(value) || "Enter a whole number";
    },
    percent(value) {
      let n = esUtils.toInt(value);
      return (/^\s*[0-9]+\s*$/.test(value) && (n >= 0) && (n <= 100)) || "Enter a whole number between 0 and 100";
    },
    currency(value) {
      let validAmount = /^ *\-? *[$]? *\-? *[0-9,]*[.]?[0-9]?[0-9]? *$/i;
      return validAmount.test(value) && value.toString().trim().length > 0 || "Enter a dollar amount";
    },
    limitInputLength(length) {
      return function (value) {
        return esUtils.isBlank(value) || value.length <= length || "This field must be less than " + length + " characters";
      };
    }
  }
};



// WEBPACK FOOTER //
// ./src/utils/FormUtils.js